import React from 'react';
import Edv from '../components/Edv';

function EdvPage() {
  return (
    <div>
      <Edv></Edv>
    </div>
  );
}

export default EdvPage;
